import type { ImportersMessages } from "./messages.en";

export const importersEs: Partial<Record<keyof ImportersMessages, string>> = {
  "importers.readiness.count.pos_stock_operations": "Correcciones y transferencias de existencias",
  "importers.readiness.count.pos_stock_operation_entries": "Movimientos de corrección",

  "importers.readiness.count.pos_jonas_records": "Filas del catálogo de origen",
  "importers.readiness.count.pos_jonas_drafts": "Vínculos de artículos",
  "importers.readiness.count.pos_jonas_reviews": "Revisiones de artículos",
  "importers.readiness.count.pos_prices": "Precios nativos por punto de venta",
  "importers.readiness.count.pos_stock_locations": "Ubicaciones de existencias",
  "importers.readiness.count.pos_stock_receipts": "Registros de recepción",
  "importers.readiness.count.pos_stock_movements": "Movimientos de recepción",
  "importers.readiness.count.gl_jonas_records": "Registros contables recibidos",
  "importers.readiness.count.gl_accounts": "Cuentas nativas",
  "importers.readiness.count.gl_lines": "Líneas de asientos nativos",
  "importers.readiness.count.lodging_jonas_records": "Registros de alojamiento recibidos",
  "importers.readiness.count.lodging_units": "Habitaciones y cabañas",
  "importers.readiness.count.lodging_stays": "Estancias nativas",
  "importers.readiness.count.lodging_history_charges": "Cargos históricos",
  "importers.readiness.count.document_index_entries": "Entradas del índice de origen",
  "importers.readiness.count.document_import_files": "Archivos de origen importados",
  "importers.readiness.count.documents": "Documentos vinculados",
  "importers.readiness.count.document_blobs": "Archivos de documentos almacenados",

  "importers.readiness.title": "Preparación de migración",
  "importers.readiness.help": "Los totales muestran datos recibidos, no una migración completa. Aún se requieren conciliación de origen y aprobaciones financieras y de existencias.",
  "importers.readiness.generated": "Verificado",
  "importers.readiness.reconcile": "Datos presentes: conciliar con el origen",
  "importers.readiness.partial": "Faltante o parcial",
  "importers.readiness.unavailable": "No instalado",
  "importers.readiness.review": "Abrir revisión",
  "importers.readiness.printing": "Controles de impresión en vivo",
  "importers.readiness.printCounts": "{agents} agentes · {server} habilitados en servidor · {local} habilitados localmente · {unknown} estados locales desconocidos",
  "importers.readiness.disabled": "La impresión del servidor y la local informada están deshabilitadas.",
  "importers.readiness.unconfirmed": "No imprimir: algún estado está habilitado, es desconocido o ningún agente ha informado.",

  "importers.runs.title": "Historial de importaciones",
  "importers.run.errors": "Errores",
  "importers.run.warnings": "Avisos",

  "importers.history.title": "Historial de Jonas",
  "importers.history.none": "Todavía no se ha importado el historial de Jonas. Los informes solo cubren la actividad en ClubCore.",
  "importers.history.noneSince": "Todavía no se ha importado el historial de Jonas. Los informes cubren la actividad en ClubCore desde el {date}.",
  "importers.history.memberLoaded": "Historial de consumos de socios cargado",
  "importers.history.memberMissing": "Historial de consumos de socios sin importar",
  "importers.history.memberRange": "{count} movimientos, del {from} al {to}.",
  "importers.history.payablesLoaded": "Historial de cuentas por pagar cargado",
  "importers.history.payablesStaged": "Cuentas por pagar recibidas, gastos aún sin crear",
  "importers.history.payablesMissing": "Historial de cuentas por pagar sin importar",
  "importers.history.payablesRange": "{count} gastos, del {from} al {to}.",
  "importers.history.lastLoaded": "Último lote cargado el {when}.",
  "importers.history.apply.queued": "Paso de construcción en espera",
  "importers.history.apply.running": "Paso de construcción en curso",
  "importers.history.apply.done": "Paso de construcción terminado",
  "importers.history.apply.failed": "Paso de construcción fallido",
  "importers.history.applyWhen": "Antiguos socios, vínculos, proveedores y gastos; {when}.",
  "importers.history.applyError": "El último intento se detuvo con: {error}",
  "importers.history.cutOver": "Los informes toman los consumos del historial hasta el {date} y de ClubCore después.",
  "importers.history.sources": "Fuentes cargadas",
  "importers.history.completenessBoundary": "Los lotes recibidos prueban una importación, no que se hayan entregado o aceptado todos los datos de Jonas.",
  "importers.history.unlinkedHouseholds": "Transacciones de socios sin hogar vinculado: {count}",
  "importers.history.unlinkedSuppliers": "Gastos importados sin proveedor: {count}",
  "importers.history.receivedRows": "Filas recibidas",
  "importers.history.skippedRows": "Filas omitidas",
  "importers.history.notReceived": "Ningún lote recibido",
  "importers.history.source.former_members": "Exsocios",
  "importers.history.source.pos_items": "Líneas históricas de TPV",
  "importers.history.source": "Fuente",
  "importers.history.batches": "Lotes",
  "importers.history.rows": "Filas",
  "importers.history.covers": "Fechas",
  "importers.history.loadedAt": "Última carga",
  "importers.history.source.member_tx": "Movimientos de socios",
  "importers.history.source.vendors": "Proveedores",
  "importers.history.source.ap_invoices": "Facturas de proveedores",
  "importers.history.source.gl_ap_lines": "Líneas contables de proveedores",
  "importers.history.source.gl_monthly": "Contabilidad general por mes",
  "importers.history.source.cheques": "Cheques",
  "importers.history.source.cheque_invoices": "Facturas pagadas por cheque",
  "importers.history.source.codes": "Tablas de códigos",
  "importers.history.source.gl_accounts": "Plan de cuentas",
  "importers.history.source.gl_divisions": "Divisiones contables",
  "importers.recon.title": "Conciliación de saldos de Jonas",
  "importers.recon.subtitle": "El historial de Jonas de cada cuenta, registrado antes del día del saldo inicial, frente a su saldo de Jonas traspasado. Se conserva el saldo de Jonas; aquí no se contabiliza nada.",
  "importers.recon.download": "Descargar CSV",
  "importers.recon.show": "Mostrar",
  "importers.recon.differsOnly": "Cuentas con diferencias",
  "importers.recon.all": "Todas las cuentas",
  "importers.recon.counts": "{households} cuentas: {matches} coinciden, {differs} difieren.",
  "importers.recon.emptyTitle": "No hay diferencias",
  "importers.recon.emptyBody": "El historial de cada cuenta suma su saldo de Jonas.",
  "importers.recon.account": "Cuenta",
  "importers.recon.member": "Socio",
  "importers.recon.history": "Total del historial",
  "importers.recon.jonas": "Saldo de Jonas",
  "importers.recon.difference": "Diferencia",
  "importers.recon.state": "Resultado",
  "importers.recon.state.matches": "Coincide",
  "importers.recon.state.differs": "Difiere",
  "importers.recon.state.no_history": "Sin historial",
  "importers.recon.state.nothing": "Sin historial ni saldo",
};
